import * as React from 'react';
export const IcMobileReceive = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.12 2.88C16.56 2.32 15.79 2 15 2H9c-.8 0-1.56.32-2.12.88S6 4.21 6 5v14c0 .8.32 1.56.88 2.12S8.21 22 9 22h6c.8 0 1.56-.32 2.12-.88S18 19.79 18 19V5c0-.8-.32-1.56-.88-2.12zm-4.24 16.76c-.23.23-.55.37-.88.37-.25 0-.49-.07-.69-.21-.21-.14-.37-.33-.46-.56a1.27 1.27 0 01-.07-.72c.05-.24.17-.47.34-.64.17-.17.4-.29.64-.34.24-.05.49-.02.72.07.23.09.42.25.56.46.14.21.21.45.21.69 0 .33-.13.65-.37.88zm1.82-6.94l-2 2c-.09.09-.2.17-.33.22-.12.05-.25.08-.38.08s-.26-.03-.38-.08-.23-.12-.33-.22l-2-2a.996.996 0 111.41-1.41l.29.29V4.99c0-.55.45-1 1-1s1 .45 1 1v6.59l.29-.29a.996.996 0 111.41 1.41h.02z'
      fill='currentColor'
    />
  </svg>
);
